import { Table, Input, Button, Modal, DatePicker } from "antd";
import React, { useEffect, useState } from "react";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";
import excelPng from "../../img/excel.png";
import {
    formatDate,
    amountFormat,
    coinMultiFormat,
    coinDivideFormat
  } from "../../lib/util/numberUtil";

const Search = Input.Search;
const { RangePicker } = DatePicker;
const now = new Date();

const ParentTransactionList = () => {
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [type, setType] = useState(0);
    const [searchText, setSearchText] = useState("");

    const [serverWalletInfo, setServerWalletInfo] = useState({});
    const [feeWalletInfo, setFeeWalletInfo] = useState({});
    let isWalletInfoLoaded = false;

    const [deleted, setDeleted] = useState(false);
    const [date, setDate] = useState({
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD")
      });

    const getList = async () => {

    };

    useEffect(()=>{
        if (!isWalletInfoLoaded) {
            isWalletInfoLoaded = true;
            getWalletInfo();
        }
    },[])

    const getWalletInfo = async() => {
        console.log("getWalletInfo");
        
        const res1 = await httpGet(httpUrl.serverWalletInfo, [401],{});
        setServerWalletInfo(res1.data);     
        const res2 = await httpGet(httpUrl.serverWalletInfo, [4],{});
        setFeeWalletInfo(res2.data);         
    };

    const handleTableChange = (page) => {
        if (page.current !== pagination.current) {
            setPagination({
                ...pagination,
                current: page.current
            });
        } else if (page.pageSize !== pagination.pageSize) {
            setPagination({
                ...pagination,
                current: 1,
                pageSize: page.pageSize
            });
        }
    };

    const list = [
        {
            idx: 60700,
            applyDate: '2023-09-01 11:19',
            txId:'0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A',
            from:'0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A',
            to:'0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A',
            division: "이용수수료",
            status:'완료',
            throne:'0.01326252',
            charge:'0.0003356'
          },
          {
            idx: 60699,
            applyDate: '2023-08-31 13:36',
            txId:'0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A',
            from:'0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A',
            to:'0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A',
            division: "입금",
            status:'완료',
            throne:'0.01326252',
            charge:'0.0003356'
          },
          {
            idx: 60698,
            applyDate: '2023-08-31 13:32',
            txId:'0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A',
            from:'0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A',
            to:'0x4815A7SD55WF1A33F8A5WDFF1A8S52F8A',
            division: "입금",
            status:'완료',
            throne:'0.01326252',
            charge:'0.0003356'
          },
    ]
    

    const columns = [
        {
            title: "거래번호",
            dataIndex: "idx",
            className: "column-center",
        },
        {
            title: "일시",
            dataIndex: "applyDate",
            className: "column-center",
            // render: (data) => <div>{moment(data).format("YYYY-MM-DD HH:mm:ss")}</div>
        },
        {
            title: "TXID",
            dataIndex: "txid",
            className: "column-center",
        },
        {
            title: "FROM",
            dataIndex: "from",
            className: "column-center",
        },
        {
            title: "TO",
            dataIndex: "to",
            className: "column-center",
        },
        {
            title: "구분",
            dataIndex: "division",
            className: "column-center",
        },
        {
            title: "상태",
            dataIndex: "status",
            className: "column-center",
        },
        {
            title: "수량(USDT)",
            dataIndex: "throne",
            className: "column-center",
        },
        {
            title: "수수료(BNB)",
            dataIndex: "charge",
            className: "column-center",
        },
    ];

    const reset =() =>{
        setType(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
        setSearchText("")
    };

    const changeDate =(type) =>{
    if (type ==='today'){
        setType(0)
        setDate({
            start: moment().format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    } else if (type === 'week'){
        setType(1)
        setDate({
            start: moment().add(-7, 'd').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    }else if (type === 'threeMonth'){
        setType(2)
        setDate({
            start:  moment().add(-3, 'M').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
    }else{
        setType(3)
        setDate({
            start: moment('2023-01-01').format('YYYY-MM-DD'),
            end: moment().format('YYYY-MM-DD')
        })
        }

    };
    const onChangeRangePicker = async (e, selectDate, value) => {
    setType(4)
    setDate({
        start: moment(selectDate[0]).format('YYYY-MM-DD'),
        end: moment(selectDate[1]).format('YYYY-MM-DD')
    })
    };

    const disabledDate = (current) => {
    return current && current > moment().endOf('day');
    };
    
    return (
             <div id ="parentTransactionList" className="main">
                <div className="main-title">
                집금계좌
                </div>
                <div className="bank-bar">
                    <div className="bank-box">
                        <div>
                            집금계좌(USDT): 
                            <span>{serverWalletInfo.address}</span>
                        </div>
                        <div>
                            집금계좌 잔액: 
                            <span>{amountFormat(serverWalletInfo.balance, 401)} USDT (사용불가: {amountFormat(serverWalletInfo.lockBalance, 401)} USDT)</span>
                        </div>
                    </div>
                    <div className="bank-box">
                        <div>
                        수수료계좌(BNB):
                        <span> {feeWalletInfo.address}</span>
                        </div>
                        <div>
                        수수료계좌 잔액: 
                        <span> {amountFormat(feeWalletInfo.balance, 4)} BNB (사용불가: {amountFormat(feeWalletInfo.lockBalance, 4)} BNB)</span>
                        </div>
                    </div>
                </div>
                    {/* <div className="top-bar">
                    <div>
                            <Button className={type === 0 && "active"} onClick={()=>changeDate('today')}>
                                금일
                            </Button>
                            <Button  className={type === 1 && "active"} onClick={()=>changeDate('week')}>
                                1주일
                            </Button>
                            <Button className={type === 2 && "active"} onClick={()=>changeDate('threeMonth')}>
                                3개월
                            </Button>
                            <Button className={type === 3 && "active"} onClick={()=>changeDate('all')}>
                                전체
                            </Button>
                            <p>
                            <RangePicker
                                style={{padding:5, borderRadius:5, marginRight:10,  border:'1px solid #888',height:32}}
                                locale={locale}
                                format={"YYYY-MM-DD"}
                                allowClear={false}
                                picker="date"
                                value={[
                                moment(date.start, "YYYY-MM-DD"),
                                moment(date.end, "YYYY-MM-DD"),
                                ]}
                                onChange={onChangeRangePicker}
                                disabledDate={disabledDate}
                            />
                            </p>
                            <Button>
                                전체
                            </Button>
                            <Button>
                                전체
                            </Button>
                            <Search
                                placeholder="검색어를 입력하세요"
                                className="search-input"
                                enterButton
                                allowClear
                                // onSearch={onSearch}
                            />
                            </div>
                         <Button onClick={()=>reset()}>
                                초기화
                        </Button>
                    </div>

                    <div className="top-table">
                        <div className="top-table-container">
                                <div>
                                총 <span> 3</span>건이 검색되었습니다.
                                </div>
                                <div>
                                <Button
                                    className="download-btn"
                                    // onClick={() => onDownload()}
                                > 
                                <div>
                                    <img src={excelPng} alt="" />
                                    다운로드
                                    </div>
                                </Button>
                                </div>
                         </div>

                        <Table
                            rowKey={(record) => record.idx}
                            dataSource={list}
                            columns={columns}
                            pagination={pagination}
                            onChange={handleTableChange}
                        />
                     </div> */}
        </div>
    );

}

export default ParentTransactionList;
